export const state = () => ({
  consignees: [],
  totalConsignees: 0,
  currentPage: 1
})

export const mutations = {
  resetState(currentState) {
    Object.assign(currentState, state())
  },
  setConsignees(state, consignees) {
    state.consignees = consignees
    state.totalConsignees = consignees.length
  },
  setCurrentPage(state, page) {
    state.currentPage = page
  }
}

export const actions = {
  async initialize({ dispatch, commit }, route) {
    let p = null
    if (route) {
      p = parseInt(route.query.p)
      const r = parseInt(route.query.r)

      if (r && [20, 40, 60, 100].includes(r)) {
        commit('company/setPageLimit', r, { root: true })
      }
    }

    await dispatch('fetchCompanyConsignees', p)
  },
  async fetchCompanyConsignees({ commit, rootState, rootGetters }, p) {
    const requestId = 'fetchCompanyConsignees'
    this.$axios.cancel(requestId)
    try {
      const { from, to } = rootGetters['company/arrivalDateBetween']
      const {
        country,
        tradeType: shipmentType,
        company: { companyId, pageLimit }
      } = rootState
      const sortBy = rootGetters['company/companySortBy']
      const { data } = await this.$axios.$get(
        `${COMPANY_API_URL}/companies/${companyId}/consignees`,
        {
          params: {
            arrivalDates: `${from}-${to}`,
            sortBy,
            country,
            shipmentType
          }
        }
      )

      commit('setConsignees', data.items)

      if (p && p > 1) {
        const total = Math.min(10000, data.items.length)
        const pageCount = Math.ceil(total / pageLimit)
        if (pageCount) {
          p = p > pageCount ? pageCount : p
          commit('setCurrentPage', p)
        }
      }
    } catch (error) {
      if (this.$axios.isCancel(error)) {
        return // request has been canceled
      }
      throw error
    }
  }
}
